import React from 'react';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import FormWrapper from '../../../../../Components/Form/FormWrapper';
import InputField from '../../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../../Components/Button/SubmitButton';

export interface ElectronicExaminationSearchVLValues {
	rcId: string;
}

interface Props {
	onClose: () => void;
	onSubmit: (values: ElectronicExaminationSearchVLValues) => void;
}

const validationSchema = yup.object({
	rcId: yup
		.string()
		.min(6, 'nczi.examination.vl.search.rcId')
		.required('nczi.examination.vl.search.rcId'),
});

const ElectronicExaminationSearchVLModalContent: React.FC<Props> = props => {
	const { onSubmit, onClose } = props;

	const formMethods = useForm<ElectronicExaminationSearchVLValues>({
		defaultValues: {},
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = async (values: ElectronicExaminationSearchVLValues) => {
		onSubmit(values);
		onClose();
	};

	return (
		<div>
			<FormWrapper formMethods={formMethods}>
				<InputField
					label='nczi.examination.vl.search.rcId'
					name='rcId'
					isRequired
				/>
				<div className='mt-4'>
					<SubmitButton title='base.shared.search' onSubmit={handleSubmit} />
				</div>
			</FormWrapper>
		</div>
	);
};

export default ElectronicExaminationSearchVLModalContent;
